$shm_hitalama_project_codex $shm_codex_app
	width? 432
	width_px \432px
	project_id \
	style *
		^
		width <= width_px
		flexBasis <= width_px
		flexGrow 0
		flexShrink 0
		minWidth \24rem
